import SelectRenderer from "./SelectRenderer";
import React from "react";

const MultiValueSelectRenderer = (params) => {
  if (params.value) {
    const items = params.value.split(", ");

    if (items.length > 1) {
      return (
        <SelectRenderer
          onChangeHandler={() => {}}
          value={items[0].text}
          options={items.map((item) => ({
            key: item,
            text: item,
            value: item,
          }))}
          noPlaceholder={true}
        />
      );
    } else {
      return <div>{params.value}</div>;
    }
  }
  return null;
};

export default MultiValueSelectRenderer;
